var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 36,
    rx: 6,
    fill: "#1B16E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.618 15.836c-.02 1.672 1.443 2.605 2.546 3.16 1.133.568 1.514.933 1.51 1.442-.01.779-.904 1.123-1.742 1.136-1.462.023-2.311-.407-2.987-.733l-.527 2.543c.678.322 1.933.604 3.235.616 3.055 0 5.054-1.557 5.064-3.97.012-3.063-4.104-3.233-4.076-4.602.01-.415.393-.858 1.234-.97.417-.058 1.566-.101 2.868.518l.512-2.46A7.583 7.583 0 0029.533 12c-2.876 0-4.898 1.578-4.915 3.836zm12.55-3.624c-.558 0-1.028.336-1.238.851L31.566 23.82h3.053l.607-1.733h3.731l.352 1.733H42l-2.348-11.607h-2.484zm.427 3.136l.88 4.358h-2.412l1.532-4.358zm-16.678-3.136L18.51 23.819h2.909l2.405-11.607h-2.908zm-4.304 0l-3.027 7.9-1.225-6.717c-.144-.75-.712-1.183-1.342-1.183H6.07L6 12.549c1.016.228 2.17.595 2.87.988.428.24.55.45.69 1.02l2.32 9.262h3.075l4.713-11.607h-3.055z",
    fill: "#fff"
  })));
}
export default SvgVisa;